// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"324":"5d3701c1","466":"df0cd3e0","471":"6f6e3bc2","607":"4eedcac3","883":"96a55e87"}[chunkId] + ".chunk.js";
};